import { Route, Routes, useNavigate } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { useDispatch, useSelector } from "react-redux";
import { loginSelector, setLocalLogout } from "../../redux/slices/loginSlice";
import { LOGIN_STATUS } from "../../utils/Constant";
import { updateSelectedMenu } from "../../redux/slices/dashboardSlice";
import { ThunkDispatch } from "redux-thunk";
import React, { useEffect } from 'react';
import CheckUserStatus from "../login/CheckUserStatus";
import { toast } from "react-toastify";

function AppRoute() {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const loginStore = useSelector(loginSelector);
  const navigate = useNavigate();

  useEffect(() => {
    const appAuth = JSON.parse(localStorage.getItem('app-auth') || '{}');
    const { resetToken } = appAuth;

    if (resetToken) {
      const tokenPayload = JSON.parse(atob(resetToken.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);

      if (currentTime >= tokenPayload.exp) {
        // Refresh token is expired, force logout
        toast.error('Session expired');
        localStorage.clear();
        dispatch(setLocalLogout({}));
        navigate('/login');
      }
    }
  }, [dispatch, navigate]);

  const href = window.location.href;
  let path: string = href.split("#")[1];
  if (path) {
    path = path.replace("/", "");
  }
  if (
    path &&
    !path.includes("login") &&
    loginStore.status === LOGIN_STATUS.AUTHENTICATED
  ) {
    dispatch(updateSelectedMenu(path));
  } else if (!path && loginStore.status === LOGIN_STATUS.AUTHENTICATED) {
    dispatch(updateSelectedMenu("dashboard"));
  }

  if(loginStore.status === LOGIN_STATUS.AUTHENTICATED){
    if (window.location.search.includes('code=')) {
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    }
  }

  return (
    <>
      {loginStore.status === LOGIN_STATUS.AUTHENTICATED && <CheckUserStatus />}
      <Routes>
        {loginStore.status === LOGIN_STATUS.AUTHENTICATED ? (
          <Route path="/*" element={<PrivateRoutes />} />
        ) : (
          <Route path="/*" element={<PublicRoutes />} />
        )}
      </Routes>
    </>
  );
}

export default AppRoute;